import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

/**
 * @example
 * <div data-controller="accordion" data-accordion-open-value="true">
 *  <button data-action="accordion#toggle">Toggle</button>
 *  <div data-accordion-target="panel">Panel</div>
 * </div>
 */
export class AccordionController extends Controller {
  static values = { open: Boolean };
  static targets = ["panel", "input"];

  connect() {
    this.isOpen = this.hasOpenValue ? this.openValue : false;
    this.#update();
  }

  open() {
    this.isOpen = true;
    this.#update();
  }

  close() {
    this.isOpen = false;
    this.#update();
  }

  toggle(e) {
    this.isOpen = !this.isOpen;
    // aria-expandedが設定されていたら、トグル時に値を更新する(ariaExpandedは文字列)
    if (e.currentTarget.ariaExpanded) {
      e.currentTarget.ariaExpanded = this.isOpen;
    }
    this.#update();
  }

  #update() {
    this.element.classList.toggle("is-open", this.isOpen);

    if (this.isOpen) {
      $(this.panelTargets).stop().slideDown();
    } else {
      $(this.panelTargets).stop().slideUp();
    }

    for (const input of this.inputTargets) {
      input.disabled = !this.isOpen;
      // モバイルのflatpickrの場合、隣にコピーされたinputがある
      if (input.classList.contains("flatpickr-input")) {
        const sibling = input.nextElementSibling;
        if (sibling && sibling.classList.contains("flatpickr-mobile")) {
          sibling.disabled = !this.isOpen;
        }
      }
    }
  }
}
